import styles from './notes-unread-dot.module.css'

import * as React from 'react'

import { NOTES_V2_MENTIONS } from '@disco/constants/FeatureTypes'
import { useGetNotesUnreadQuery } from '@disco/state-management/api/discussions'
import { getConstanceSetting } from '@disco/state-management/selectors/user'

import type { TrackId } from 'types/track'

import { useSelector } from 'hooks/use-redux'

type Props = {
  trackId: TrackId
}

/**
 * Red dot shown on the Notes tab when the track has unread internal-note
 * activity for the current user. Gated behind NOTES_V2_MENTIONS.
 */
const NotesUnreadDot = ({ trackId }: Props): React.ReactElement | null => {
  const enabled = useSelector(state =>
    Boolean(getConstanceSetting(state, NOTES_V2_MENTIONS)),
  )
  const { data: unread } = useGetNotesUnreadQuery(trackId, {
    skip: !enabled,
    refetchOnMountOrArgChange: true,
  })

  if (!enabled || !unread) return null

  return (
    <span
      className={styles.dot}
      role="status"
      aria-label="Unread notes"
      data-testid="notes-unread-dot"
    />
  )
}

export default NotesUnreadDot
